import { DASHBOARD_AGENTS_FORM_LOADER } from "./dashboard_agents_form_loader";

export const DASHBOARD_AGENTS_NEW_LOADER = DASHBOARD_AGENTS_FORM_LOADER;
